import React, { useEffect } from "react";

export const Home = () => {
  useEffect(() => {
    window.location.href = "/authentication/login";
  });

  return <>redirecting...</>;
};

export default Home;
